import TableTemplate, {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { TableCell } from "@mui/material";
import { IUpairSahraOrderReport } from "../../../Interfaces/uPairInterfaces";
import { useContext, useState } from "react";
import Modal from "../../../Components/Modal/Modal";
import HuntStrategyChancesTable from "../../Order/HuntChances/HuntStrategyChancesTable";
import Button from "../../../Components/Button";
import { CommonTableUI } from "../../TableTemplate/common";
import { OrderStatus } from "../../../Interfaces/orderInterfaces";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import DeleteIcon from "@mui/icons-material/Delete";
import { NLegOrderSahraOrderTableAdditional } from "./SahraOrderAdditional";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PauseIcon from "@mui/icons-material/Pause";
import useRequest from "../../../Hooks/useRequest";
import { WrappedTimeSeriesChart } from "../../../Components/Timeseries/WrappedTimeSeriesChart";
import TimelineIcon from "@mui/icons-material/Timeline";
import { useAppDispatch } from "../../../App/hooks";
import EditIcon from "@mui/icons-material/Edit";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import {
  bulkCancelNLegsOrder,
  bulkPauseNLegOrder,
  bulkResumeNLegOrder,
  cancelAllNLegsOrders,
  cancelBulkNLegSahraFillOrder,
  cancelNLegOrder,
  getNLegGraph,
  getNLegSahraOrderTable,
  getNLegShekarChanceTable,
  pauseAllNLegsOrders,
  pauseNLegOrder,
  resumeAllNLegsOrders,
  resumeNLegOrder,
} from "../../../Requests/nLegsRequests";
import {
  setNLegsEditFlag,
  setNLegsEditRowValues,
} from "../../../Features/NLegs/nLegsSlice";
import {
  INLegOrderFillSearchParams,
  INLegsTableReport,
} from "../../../Interfaces/nLegsInterfaces";
import { NLegOrderTableSearchParamContext } from "./NLegsOrderTable";

const NLegOrderTableAdditionalHeader = ({
  selectedRowsIds,
  setSelectedRowsIds,
  onAction,
  isSelectAll,
}: IAdditionalHeaderProps) => {
  const [loading, setLoading] = useState(false);
  const searchParam = useContext(NLegOrderTableSearchParamContext).searchParam;
  const legCount = useContext(NLegOrderTableSearchParamContext).legCount;

  const getProperCancelOrderFunction = () => {
    if (isSelectAll) return cancelAllNLegsOrders(searchParam, legCount);
    return bulkCancelNLegsOrder(selectedRowsIds);
  };

  const bulkCancelOrderHandler = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    if (!selectedRowsIds.length) return;
    getProperCancelOrderFunction()
      .then((resp) => {
        onAction();
        toast.success(resp.msg);
        setSelectedRowsIds([]);
      })
      .catch(packetErrorHandler);
  };

  const getProperPauseOrderFunction = () => {
    if (isSelectAll) return pauseAllNLegsOrders(searchParam, legCount);
    return bulkPauseNLegOrder(selectedRowsIds);
  };

  const bulkPauseOrderHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!selectedRowsIds.length) return;
    getProperPauseOrderFunction()
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const getProperPlayOrderFunction = () => {
    if (isSelectAll) return resumeAllNLegsOrders(searchParam, legCount);
    return bulkResumeNLegOrder(selectedRowsIds);
  };

  const bulkPlayOrderHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!selectedRowsIds.length) return;
    getProperPlayOrderFunction()
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const cancelAllOpenOrdersHandler = () => {
    if (!selectedRowsIds.length) return;
    setLoading(true);
    cancelBulkNLegSahraFillOrder({ nLegOrderIds: selectedRowsIds })
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading ? <FullScreenLoading /> : <></>}
      <TableCell></TableCell>
      <TableCell>
        <div className="flex flex-row">
          <div
            onClick={selectedRowsIds.length ? bulkPauseOrderHandler : undefined}
            className="hover:bg-slate-200 transition-all rounded p-1"
          >
            <PauseIcon
              className={`text-sky-900 cursor-pointer  ${
                selectedRowsIds.length ? "text-sky-900 " : "text-gray-300"
              } transition-all`}
            />
          </div>
          <div
            onClick={selectedRowsIds.length ? bulkPlayOrderHandler : undefined}
            className="hover:bg-slate-200 transition-all rounded p-1"
          >
            <PlayCircleIcon
              className={`text-sky-900 cursor-pointer ${
                selectedRowsIds.length ? "text-sky-900 " : "text-gray-300"
              } transition-all`}
            />
          </div>
        </div>
      </TableCell>
      <TableCell></TableCell>

      <TableCell>
        <div
          onClick={selectedRowsIds.length ? cancelAllOpenOrdersHandler : undefined}
          className={`text-xs py-1 px-2 rounded ${
            selectedRowsIds.length
              ? "bg-red-700 text-white cursor-pointer"
              : "bg-white text-gray-500 border-[1px] border-gray-300 cursor-not-allowed"
          }`}
        >
          حذف سفارشات باز
        </div>
      </TableCell>
      <TableCell></TableCell>

      <TableCell>
        <div
          className={`transition-all rounded p-1 ${
            selectedRowsIds.length
              ? "hover:bg-red-100 cursor-pointer"
              : "cursor-not-allowed"
          }`}
          onClick={selectedRowsIds.length ? bulkCancelOrderHandler : undefined}
          aria-disabled={!selectedRowsIds.length}
        >
          <DeleteIcon
            fontSize="small"
            className={`cursor-pointer ${
              selectedRowsIds.length ? "text-red-900 " : "text-gray-300"
            } transition-all`}
          />
        </div>
      </TableCell>
    </>
  );
};

const NLegOrderTableAdditionalCol: React.FC<{
  row: INLegsTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isChancesOpen, setIsChancesOpen] = useState(false);
  const [isOrderFillTableOpen, setIsOrderFillTableOpen] = useState(false);
  const [isGraphModalOpen, setIsGraphModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const editHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch(setNLegsEditRowValues({ ...row }));
    dispatch(setNLegsEditFlag(true));
  };

  const orderGraphRequest = useRequest(
    () => getNLegGraph(row.id),
    packetErrorHandler
  );
  const cancelOrderHandler = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    cancelNLegOrder(row.id)
      .then((resp) => {
        onAction();
        toast.success(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const pauseOrderHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    pauseNLegOrder(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const playOrderHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    resumeNLegOrder(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const getGraphModalUI = () => {
    if (!orderGraphRequest.response) return null;
    return (
      <div className="chart-fill-modal">
        <WrappedTimeSeriesChart dataset={orderGraphRequest.response} className="h-full w-full" />
      </div>
    );
  };

  const nLegModalBtnClickHandler = () => {
    orderGraphRequest.fetchData();
    setIsGraphModalOpen(true);
  };

  const cancelAllOpenOrdersHandler = () => {
    setLoading(true);
    cancelBulkNLegSahraFillOrder({ nLegOrderIds: [row.id] })
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const getOrderFillTableUI = () => (
    <TableTemplate<INLegOrderFillSearchParams, IUpairSahraOrderReport>
      refreshTableTime={5000}
      getDataTable={(_, offset, pageSize) =>
        getNLegSahraOrderTable({ nLegId: row.id }, offset, pageSize)
      }
      TableUI={({ reports, onAction }) => (
        <div className="w-full flex flex-col justify-end items-start">
          {reports && reports.report && reports.report.length ? (
            <div
              className="border-2 border-red-700 rounded flex justify-center items-center h-12 py-2 px-3"
              onClick={cancelAllOpenOrdersHandler}
            >
              حذف سفارشات باز
            </div>
          ) : (
            <></>
          )}
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            AdditionalBody={NLegOrderSahraOrderTableAdditional}
          />
        </div>
      )}
    />
  );

  return (
    <>
      {loading ? <FullScreenLoading /> : <></>}
      <TableCell>
        <div
          className="hover:bg-slate-300 transition-all rounded p-1"
          onClick={editHandler}
        >
          <EditIcon className="text-sky-700 cursor-pointer" />
        </div>
      </TableCell>
      <TableCell>
        {row.orderStatus !== OrderStatus.Cancelled && row.isActive ? (
          <div className="hover:bg-slate-300 transition-all rounded p-1">
            <PauseIcon
              className="text-sky-700 cursor-pointer"
              onClick={pauseOrderHandler}
            />
          </div>
        ) : null}
        {row.orderStatus !== OrderStatus.Cancelled && row.isActive === false ? (
          <div className="hover:bg-slate-300 transition-all rounded p-1">
            <PlayCircleIcon
              className="text-sky-700 cursor-pointer"
              onClick={playOrderHandler}
            />
          </div>
        ) : null}
      </TableCell>
      <TableCell>
        {isChancesOpen ? (
          <Modal
            UI={
              <HuntStrategyChancesTable
                getData={(_, offset, pageSize) =>
                  getNLegShekarChanceTable({ nLegId: row.id }, offset, pageSize)
                }
              />
            }
            onClose={() => setIsChancesOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsChancesOpen(true)}
          text="شانس ها"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        {isOrderFillTableOpen ? (
          <Modal
            UI={getOrderFillTableUI()}
            onClose={() => setIsOrderFillTableOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsOrderFillTableOpen(true)}
          text="سفارشات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
      <TableCell>
        <>
          {isGraphModalOpen ? (
            <Modal
              onClose={() => setIsGraphModalOpen(false)}
              UI={getGraphModalUI()}
              fullScreen
            />
          ) : null}
          <Button
            onClick={nLegModalBtnClickHandler}
            text={<TimelineIcon className="!text-base" />}
            variant="contained"
            className="table-btn"
          />
        </>
      </TableCell>
      <TableCell>
        {row.orderStatus !== OrderStatus.Cancelled ? (
          <div
            onClick={cancelOrderHandler}
            className="hover:bg-red-100 transition-all rounded p-1"
          >
            <DeleteIcon
              fontSize="small"
              className="text-red-700 cursor-pointer"
            />
          </div>
        ) : null}
      </TableCell>
    </>
  );
};

export const NLegOrderTableAdditional: IAdditional<INLegsTableReport> = {
  getHeader: NLegOrderTableAdditionalHeader,
  getRow: NLegOrderTableAdditionalCol,
};
